import { format } from 'date-fns';

import { i18n } from './i18n';

const MILLISECONDS_TO_SECONDS = 1000;
const MILLISECONDS_TO_MINUTES = 60 * 1000;
const MILLISECONDS_TO_HOUR = 60 * 60 * 1000;
const MILLISECONDS_TO_DAY = 24 * 60 * 60 * 1000;

// timeFormatter formats time to a friendly time string the same way as
// backend formats by-line time string
export const timeFormatter = (savedTime: Date, formatMessage: any) => {
	let formattedTime;
	const timeNow = new Date();
	const timeDifference = timeNow.getTime() - savedTime.getTime();
	if (timeDifference / MILLISECONDS_TO_SECONDS < 4) {
		formattedTime = formatMessage(i18n.aMomentAgo);
	} else if (timeDifference / MILLISECONDS_TO_MINUTES < 1) {
		formattedTime = formatMessage(i18n.lessThanAMinuteAgo);
	} else if (timeDifference / MILLISECONDS_TO_MINUTES < 2) {
		formattedTime = formatMessage(i18n.oneMinuteAgo);
	} else if (timeDifference / MILLISECONDS_TO_MINUTES < 50) {
		const roundedMinutes = Math.round(timeDifference / MILLISECONDS_TO_MINUTES);
		formattedTime = formatMessage(i18n.xMinutesAgo, { time: roundedMinutes });
	} else if (timeDifference / MILLISECONDS_TO_MINUTES < 90) {
		formattedTime = formatMessage(i18n.oneHourAgo);
	} else {
		const yesterday = timeNow;
		yesterday.setDate(timeNow.getDate() - 1);
		const savedTimeWasYesterday = yesterday.toLocaleDateString() === savedTime.toLocaleDateString();
		if (savedTimeWasYesterday && timeDifference / MILLISECONDS_TO_HOUR > 5) {
			// yesterday and more than 5 hours ago
			formattedTime = formatMessage(i18n.yesterday, {
				time: savedTime.getHours(),
			});
		} else if (timeDifference / MILLISECONDS_TO_DAY < 1) {
			const roundedHours = Math.round(timeDifference / MILLISECONDS_TO_HOUR);
			formattedTime = formatMessage(i18n.xHoursAgo, { time: roundedHours });
		} else {
			formattedTime = format(savedTime, 'PP');
		}
	}
	return formattedTime;
};
